import { useEffect, useState, useContext, useRef } from "react";
import { createBrowserRouter, RouterProvider, useNavigate } from "react-router";
import axios from 'axios';

import { AppContext } from '../../../context.js';

import Helmet from "../../components/helmet.js";
import { FilePlus, UserPlus, Edit } from "../../../files/icons/index.js";

function Partners() {
  const context = useContext(AppContext);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  const [partners, setPartners] = useState(null);

  useEffect(() => {
    let u = context.addSpiner();
    axios.all([
      axios.post('/api/admin/partners', {
        filter: {
          //role: ["physician"]
        }
      }),
    ]).then(axios.spread((partners) => {
      setPartners(partners.data.partners);
      setLoading(false);
    })).catch((e) => {
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }, []);

  function renderPartners() {
    if (!partners || partners.length === 0) {
      return (
        <div className="d-flex justify-content-center align-items-center mt-4">
          <div className="typo-normal-150 text-muted">No partners</div>
        </div>
      );
    }

    return partners.map((partner, i) => {
      return (
        <div className="card clickable mb-2" key={partner.id} onClick={() => navigate(`/settings/partner/${partner.id}`)}>
          <div className="card-header sm">
            <div className="row">
              <div className="col-xs-6">
                <div className="typo-strong-200">{partner.title}</div>
                <div className="typo-normal-150">{partner.description}</div>
              </div>
              <div className="col-xs-3">
                <div className="typo-normal-150">{partner.partnerPortal ? "Partner Portal" : ""}</div>
                <div className="typo-normal-150">{partner.referralProvider ? "Referral Provider" : ""}</div>
                <div className="typo-normal-150">{partner.serviceProvider ? "Service Provider" : ""}</div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  }

  if (loading) {
    return <></>;
  }

  return (
    <>
      <Helmet title="Settings | Partners" />

      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col-xs-12 col-lg-offset-2 col-lg-8">
            <div className="d-flex justify-content-between align-items-center">
              <div className="">
                <div className="typo-hero-small">Partners</div>
                <div className="typo-normal-175">Manage and oversee all partner organizations associated with your practice</div>
              </div>
              <div className="w-25 text-end">
                <div className="item typo-normal-150 ms-2" onClick={() => navigate('/settings/partners/create')}><UserPlus height={16} width={16} color={'grey'} /> Create</div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-lg-offset-2 col-lg-8">
            {renderPartners()}
          </div>
        </div>
      </div>
    </>
  );
}

export default Partners;